export default __webpack_public_path__ + "static/media/fon-top-content_1.ac91c844.png";